/**
 * Map the resources-by-establishment stacked chart.
 */

import type { BarChartData } from '@/components/common/stats/HorizontalStackedBarChart';
import {
  CHART_FILTER_ELEMENT_IDS,
  type ChartFilterVisibility,
  type ChartView,
} from '@/components/charts/chart-configs';
import { chartEstablishmentCountLabel } from '@/utils/common-utils';
import { dashboardHasElement } from '@/utils/dashboard-ie-utils';

export { chartHeightForCount, hasChartSeriesData } from '@/utils/common-utils';

/** Backend already returns top-N establishments; no extra client sort. */
export function buildResourcesChartView(raw: BarChartData | null | undefined): ChartView {
  if (!raw || raw.categories.length === 0) return { chartData: null, displayCount: 0 };
  return { chartData: raw, displayCount: raw.categories.length };
}

/** Subtitle count: "N établissement(s)", empty when there is nothing to plot. */
export function resourcesChartCountTitle(displayCount: number): string {
  if (displayCount <= 0) return '';
  return chartEstablishmentCountLabel(displayCount);
}

/** Which dashboard IE filters the resources chart toolbar should show. */
export function resolveResourcesChartFilterVisibility(
  elements: { elementId: string }[],
): ChartFilterVisibility {
  const showPeriodFilter = dashboardHasElement(elements, CHART_FILTER_ELEMENT_IDS.period);
  const showDateRangeFilter = dashboardHasElement(elements, CHART_FILTER_ELEMENT_IDS.dateRange);
  const showEstablishmentFilter = dashboardHasElement(
    elements,
    CHART_FILTER_ELEMENT_IDS.establishment,
  );
  return {
    showPeriodFilter,
    showDateRangeFilter,
    showEstablishmentFilter,
    showStatusFilter: false,
    hasAnyFilter: showPeriodFilter || showDateRangeFilter || showEstablishmentFilter,
  };
}
